import { call, put, takeEvery } from "redux-saga/effects";
import { lopTinChiApi } from "../../../api/lop-tin-chi/lopTinChiApi";
import { ILopTinChiSelectRequest } from "../../../model/request/lop-tin-chi/ILopTinChiSelectRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eLopTinChiActionIds, ILopTinChiActionTypes } from "../../action-types/lop-tin-chi/ILopTinChiActions";
import { rootActions } from "../../actions/rootActions";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { ILopTinChiViewModel } from "../../../model/respone/lop-tin-chi/ILopTinChiViewModel";
import { IMonTinChi } from "../../../model/respone/lop-tin-chi/IMonTinChi";
import { monTinChiApi } from "../../../api/lop-tin-chi/monTInChiApi";
import { danhSachLopTinChiApi } from "../../../api/lop-tin-chi/danhSachLopTinChiApi";
import { NotifyHelper } from "../../../helpers/toast";
const mainAction = rootActions.lopTinChiWrapper.lopTinChi;
export function* lopTinChiSaga(): any {
  yield takeEvery(eLopTinChiActionIds.LOAD_START, loadWorker);
  yield takeEvery(eLopTinChiActionIds.INI_BY_KE_HOACH_START, iniByKeHoachWorker);
  yield takeEvery(eLopTinChiActionIds.DELETE_START, deleteWorker);
  yield takeEvery(eLopTinChiActionIds.SAVE_START, saveWorker);
  yield takeEvery(eLopTinChiActionIds.LOAD_BY_KE_HOACH_MON_START, selectByKeHoachMonWorker);
  yield takeEvery(eLopTinChiActionIds.LOAD_BY_DOT_THI_DANG_KY_START, loadByDotThiDangKyWorker);
  yield takeEvery(eLopTinChiActionIds.UPDATE_MON_TIN_CHI_START, updateMonTinChiWorker);
  yield takeEvery(eLopTinChiActionIds.DANG_KY_TU_DONG_LOP_HANH_CHINH_START, dangKyTuDongLopHanhChinhWorker);
}

function* loadWorker(action: ILopTinChiActionTypes): any {
  const res: IBaseRespone = yield call(lopTinChiApi.Select, action.payload as ILopTinChiSelectRequest);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* iniByKeHoachWorker(action: ILopTinChiActionTypes): any {
  const res: IBaseRespone = yield call(lopTinChiApi.IniByKeHoachNhomLop, action.payload as ILopTinChiSelectRequest);
  if (res.is_success) {
    yield put(mainAction.INI_BY_KE_HOACH_SUCCESS(res.data));
  } else {
    yield put(mainAction.INI_BY_KE_HOACH_ERROR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: ILopTinChiActionTypes): any {
  const res: IBaseRespone = yield call(lopTinChiApi.Deletes, action.payload as IIdsRequest);
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: ILopTinChiActionTypes): any {
  let res: IBaseRespone;
  const lopTinChi = action.payload as ILopTinChiViewModel;
  if (lopTinChi.id_lop_tc > 0) {
    res = yield call(lopTinChiApi.Update, lopTinChi);
  } else {
    res = yield call(lopTinChiApi.Insert, lopTinChi);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi"));
  }
}


function* selectByKeHoachMonWorker(action: ILopTinChiActionTypes): any {
  const res: IBaseRespone = yield call(lopTinChiApi.SelectByKeHoachMon, action.payload as ILopTinChiSelectRequest);
  if (res.is_success) {
    yield put(mainAction.LOAD_BY_KE_HOACH_MON_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_BY_KE_HOACH_MON_ERROR(res.message ?? "Có lỗi"));
  }
}

function* loadByDotThiDangKyWorker(action: ILopTinChiActionTypes): any {
  const res: IBaseRespone = yield call(lopTinChiApi.SelectMonThi, action.payload as number);
  if (res.is_success) {
    yield put(mainAction.LOAD_BY_DOT_THI_DANG_KY_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_BY_DOT_THI_DANG_KY_ERROR(res.message ?? "Có lỗi"));
  }
}

function* updateMonTinChiWorker(action: ILopTinChiActionTypes): any {
  const res: IBaseRespone = yield call(monTinChiApi.Update, action.payload as IMonTinChi);
  if (res.is_success) {
    yield put(mainAction.UPDATE_MON_TIN_CHI_SUCCESS(res.data));
  } else {
    yield put(mainAction.UPDATE_MON_TIN_CHI_ERROR(res.message ?? "Có lỗi"));
  }
}

function* dangKyTuDongLopHanhChinhWorker(action: ILopTinChiActionTypes): any {
  const res: IBaseRespone = yield call(danhSachLopTinChiApi.DangKyTuDongLopHanhChinh, action.payload as number[]);
  if (res.is_success) {
    // message rỗng = tất cả OK; có message = thành công một phần (danh sách SV bị bỏ qua).
    if (res.message) {
      NotifyHelper.Warning(res.message);
    } else {
      NotifyHelper.Success("Thêm sinh viên tự động thành công");
    }
    yield put(mainAction.DANG_KY_TU_DONG_LOP_HANH_CHINH_SUCCESS(undefined));
  } else {
    yield put(mainAction.DANG_KY_TU_DONG_LOP_HANH_CHINH_ERROR(res.message ?? "Có lỗi"));
  }
}